import baseProfileDatashape from "src/app/shared/datashapes/base-profile-datashape";
import profileDatashape from "src/app/shared/datashapes/profile.datashape";

const subscriptionDatashape = `
  id
  createdAt
  expiresAt
  rejectionDetails{
  reasons{
  issue
  otherDetails}
  rejectedAt
  rejectedBy{
  name
  surname}
  }
  user {
    id
    email
    mobile
    name
    surname
    enabled
    blacklisted
    mobileVerified
    emailVerified
  }
  status
  profile {
    ${baseProfileDatashape}
  }
`;

export default subscriptionDatashape;
